import React, { PropsWithChildren } from 'react'
import { shouldRenderReskin2025 } from '../../constant'

type Props = {
  children: JSX.Element | JSX.Element[]
  id: string
}

function Card(props: PropsWithChildren<Props>): JSX.Element {
  const { children, id } = props
  return (
    <div
      id={ id }
      className={ `curation-ui-card${shouldRenderReskin2025 ? ' reskin' : '' }` }
    >
      { children }
    </div>
  )
}

export default Card
